export default __webpack_public_path__ + "static/media/pattern-4.31a1a738.png";